import { Team } from "~/api/Api";
import yourLogoHereUrl from "~/assets/images/your-logo-here.png";
import { isWhiteLabel } from "~/utils/white-label";

/**
 * The "Your Logo Here" image an Autopto agency sees instead of a missing
 * logo, so it knows where its brand goes. Other teams, and anyone on a
 * white-label host (the agency's clients), keep the first-letter fallback:
 * returns undefined for them.
 */
export const getLogoPlaceholderUrl = (
  team: Pick<Team, "platform"> | null | undefined,
): string | undefined =>
  team?.platform === "autopto" && !isWhiteLabel() ? yourLogoHereUrl : undefined;
